export default __webpack_public_path__ + "static/media/91.70f8866a.png";